import React from "react";
import styled from "styled-components";

export const TagCardStyled = styled.div`
  min-width: 120px;
  padding: 0.2rem 1rem;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5em;
  p {
    font-size: 12px;
    color: var(--color-white);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    background-color: var(--color-purple-lighten) !important;

    p {
      color: var(--color-dark);
    }
  }
`
const TagCard = ({
                     id,
                     color,
                     name,
                     displayTags,
                     categoryId
                 }) => {

    return (
        <TagCardStyled
            key={id}
            style={{backgroundColor: categoryId !== id ? color : 'var(--color-purple-lighten)'}}
            onClick={() => displayTags(id)}
        >
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none"
                 xmlns="http://www.w3.org/2000/svg"
                 className={"tags-category"}>
                <path
                    d="M18.7337 10.1325L10.8587 2.2575C10.5437 1.9425 10.1063 1.75 9.625 1.75H3.5C2.5375 1.75 1.75 2.5375 1.75 3.5V9.625C1.75 10.1063 1.9425 10.5438 2.26625 10.8675L10.1413 18.7425C10.4563 19.0575 10.8937 19.25 11.375 19.25C11.8563 19.25 12.2937 19.0575 12.6087 18.7337L18.7337 12.6087C19.0575 12.2937 19.25 11.8563 19.25 11.375C19.25 10.8937 19.0487 10.4475 18.7337 10.1325ZM4.8125 6.125C4.08625 6.125 3.5 5.53875 3.5 4.8125C3.5 4.08625 4.08625 3.5 4.8125 3.5C5.53875 3.5 6.125 4.08625 6.125 4.8125C6.125 5.53875 5.53875 6.125 4.8125 6.125Z"
                    fill={`#${categoryId === id ? "4909AA" : "fafafa"}`}/>
            </svg>
            <p style={{color: categoryId !== id ? 'var(--color-white)' : 'var(--color-black)'}}
            > {name} </p>
        </TagCardStyled>
    )
}

export default TagCard